import Vue from 'vue'
import Router from 'vue-router'
import welcome from '@/components/welcome'
import index from '@/components/index'
import login from '@/components/login'
import improving from '@/components/improving'
import register from '@/components/register'
import memberCenter from '@/components/memberCenter'
import creatOrder from '@/components/creatOrder'
import shopCar from '@/components/shopCar'
import myOrder from '@/components/myOrder'
import afterSale from '@/components/afterSale'
import memberLog from '@/components/memberLog'
import receAddress from '@/components/receAddress'
import setpsword from '@/components/setpsword'
import phAddress from '@/components/phAddress'
import invoiceCt from '@/components/invoiceCt'
import orderDetail from '@/components/orderDetail'
import success from '@/components/success'
import paysuccess from '@/components/success2'
import communicate from '@/components/communicate'
import payment from '@/components/payment'
import goods from '@/components/goods'
import account from '@/components/account'
import news from '@/components/news'
import monthly from '@/components/monthly'
import help from '@/components/help'
Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			redirect: '/login'
		},
		{
			path: '/welcome',
			name: 'welcome',
			component: welcome

		},
		{
			path: '/',
			name: 'index',
			component: index,
			children: [{
				path: '/memberCenter',
				component: memberCenter,
				name: '会员中心',
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/creatOrder',
				component: creatOrder,
				name: '立即下单',
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/shopCar',
				component: shopCar,
				name: '购物车',
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/myOrder',
				component: myOrder,
				name: '我的订单',
				meta: {
					keepAlive: false,
				}
			},{
				path: '/monthly',
				component: monthly,
				name: '月结订单',
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/afterSale',
				name: '客诉项目',
				component: afterSale,
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/memberLog',
				component: memberLog,
				name: '积分明细',
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/receAddress',
				component: receAddress,
				name: '收货地址',
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/setpsword',
				component: setpsword,
				name: '修改密码',
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/phAddress',
				component: phAddress,
				name: '订单联系人',
				meta: {
					keepAlive: true,
				}
			}, {
				path: '/invoiceCt',
				component: invoiceCt,
				name: '发票管理',
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/account',
				name: '账号管理',
				component: account,
				meta: {
					keepAlive: true,
				}
			}, {
				path: '/orderDetail',
				name: '订单详情',
				component: orderDetail,
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/payment',
				name: '订单结算',
				component: payment,
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/goods',
				name: '购物车商品详情',
				component: goods,
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/communicate',
				name: '沟通',
				component: communicate,
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/success',
				name: '成功',
				component: success,
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/paysuccess',
				name: '成功',
				component: paysuccess,
				meta: {
					keepAlive: false,
				}
			}, {
				path: '/news',
				name: '消息列表',
				component: news,
				meta: {
					keepAlive: false,
				}
			}, ]
		},
		{
			path: '/help',
			name: 'help',
			component: help
		},
		{
			path: '/register',
			name: 'register',
			component: register

		},
		{
			path: '/improving',
			name: 'improving',
			component: improving
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '*',
			redirect: '/welcome'
		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js